import React, { Dispatch, SetStateAction } from 'react';
import {
  View, Text, StyleSheet, Pressable,
} from 'react-native';
import Colors from '../constants/Colors';
import TickIcon from './TickIcon';

export type Utility = {
  title: string,
  metric: string,
}

interface SelectUtilityProps {
  data: Utility[],
  currentMetric: Utility,
  previousMetric: Utility,
  setCurrentMetric: Dispatch<SetStateAction<Utility>>,
  setPreviousMetric: Dispatch<SetStateAction<Utility>>,
  compareToggled: boolean,
}

const SelectUtility = ({
  data, currentMetric, previousMetric, setCurrentMetric, setPreviousMetric, compareToggled,
}: SelectUtilityProps) => <View style={{ flexDirection: 'row' }}>
    {data.map((item: Utility) => {
      let legendColor: string = Colors.light.hereworksBlack500;
      let compareLegendColor: string = Colors.light.hereworksBlack200;
      const currentlySelected: boolean = item.title === currentMetric.title;
      const previouslySelected: boolean = item.title === previousMetric.title;
      const onPress = () => {
        if (currentlySelected) return;
        setPreviousMetric(currentMetric);
        setCurrentMetric(item);
      };
      if (currentlySelected) {
        legendColor = Colors.light.hereworksPurple500;
        compareLegendColor = Colors.light.hereworksYellow800;
      } else if (previouslySelected) {
        legendColor = Colors.light.hereworksDarkBlue;
        compareLegendColor = Colors.light.hereworksYellow500;
      }
      return (
        <Pressable
          style={(currentlySelected || previouslySelected) ? styles.selected : styles.unselected}
          {...{ onPress }}
          key={item.metric}
        >
          <View style={[styles.line, { backgroundColor: legendColor }]} />
          {compareToggled && (
            <View
              style={[styles.line, styles.compareLine, { backgroundColor: compareLegendColor }]}
            />
          )}
          <Text
            style={
              (currentlySelected || previouslySelected) ? styles.selectedText
                : styles.unselectedText
            }
          >
            {item.title}
          </Text>
          <View
            style={[
              styles.tickBox,
              (currentlySelected || previouslySelected) && styles.tickBoxSelected,
            ]}
          >
            {(currentlySelected || previouslySelected) && <TickIcon />}
          </View>
        </Pressable>
      );
    })}
  </View>;

const styles = StyleSheet.create({
  unselected: {
    backgroundColor: Colors.light.hereworksBlack50,
    borderColor: Colors.light.hereworksBlack100,
    borderWidth: 1.5,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 4,
    flexDirection: 'row',
  },
  selected: {
    backgroundColor: Colors.light.hereworksWhite100,
    borderColor: Colors.light.hereworksBlue50,
    borderWidth: 1.5,
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 4,
    flexDirection: 'row',
  },
  selectedText: {
    color: Colors.light.hereworksBlack500,
    alignSelf: 'center',
    fontSize: 15,
    marginHorizontal: 20,
    marginVertical: 11,
    fontFamily: 'Poppins_400Regular',
  },
  unselectedText: {
    color: Colors.light.hereworksBlack300,
    alignSelf: 'center',
    fontSize: 15,
    marginHorizontal: 20,
    marginVertical: 11,
    fontFamily: 'Poppins_400Regular',
  },
  line: {
    borderRadius: 2,
    width: 24,
    height: 2,
    marginStart: 12,
  },
  compareLine: {
    marginStart: 4,
  },
  tickBox: {
    width: 16,
    height: 16,
    borderRadius: 2,
    borderWidth: 1,
    marginEnd: 8,
    justifyContent: 'center',
    alignItems: 'center',
    borderColor: Colors.light.hereworksBlack100,
  },
  tickBoxSelected: {
    borderColor: Colors.light.hereworksDarkBlue,
  },
});

export default SelectUtility;
